<template>
  <config @submit="update($event)"></config>
</template>

<script>
	export default {
		name: 'planningDefault-add',
    components: {
      config: require('./config.vue').default,
    },
		methods:{
			update: function(config) {
        this.$notify.saveAsync(
            this.$t('planningDefault'),
            this.$store.dispatch('planningDefault.add', {data: config}),
            () => {
              this.$navigation.goto({name: 'organisation.planningDefaults'});
            }
        );
			},
		},
	};
</script>

<style>
</style>
